<i18n>
{
    "uk": {
        "buyCourse": "Придбати курс",
        "register": "Зареєструватись на курс",
        "buyForever": "Придбати курс назавжди",

        "buyCourseEvent": "Придбати подію",
        "registerEvent": "Зареєструватись на подію",
        "buyForeverEvent": "Придбати подію назавжди",


        "buyBundle": "Придбати пакунок",
        "toCourse": "До курсу",
        "toEvent": "До події",
        "startLearning": "Почати навчання",
        "startFree": "Почати безплатно",
        "changePlan": "Змінити тариф",
        "learnMore": "Дізнатись більше",
        "fillApplication": "Заповнити заявку",

        "teamAccess": {
            "textBefore": "А ще у нас є навчання ",
            "link": "для команд",
            "textAfter": " "
        },

        "pricing": {
            "fullPrice": "Повна ціна",
            "fromValue": "від {value}",
            "free": "Безоплатно",
            "₴/міс.": "₴/міс.",
            "uah": "₴",
            "oneTimePayment": "Єдиноразовий платіж",
            "monthlyPaynent": "Щомісячний платіж",
            "priceChangeTimer": "До підвищення цін залишилося:"
        },

        "plans": {
            "title": "Обирайте комфортний тариф",
            "description": "Спробуйте з тарифу за {readonly} грн/місяць або відчуйте всі переваги платформи лише за {fullaccess} грн/місяць."
        },

        "defaultDesc": {
            "buyForever": "Так доступ до курсу та всі можливості навчання (перевірка домашніх робіт, сертифікат, перегляд всіх матеріалів курсу) будуть доступні, навіть коли передплата завершиться.",
            "subIncludes": "Ви можете хоч зараз почати навчання на цьому курсі! Ваш тариф дозволяє вам дивитись всі уроки, проходити практичні заняття, отримувати рецензії, а після завершення навчання — отримати сертифікат.",
            "customPricePreface": "<a target=\"_blank\" href=\"https://savelife.in.ua/\" class=\"b-link\">«Повернись живим»</a> є першою благодійною організацією в Україні, яка отримала ліцензію на закупівлю та імпорт товарів військового та подвійного призначення.",
            "customPricePrefacePoints": {
                "accounting": "Прозора фінансова звітність",
                "donated": "Зібрано понад 6,6 мільярда гривень",
                "saveLife": "Куплена техніка допомагає зберегти життя нашим військовим"
            },
            "customPrice": "<strong>Ціну курсу</strong> визначите самі. Але вона не може складати менше {minPrice} грн.",
            "subOnly": "Спробуйте з тарифу за {readonly} грн/місяць або відчуйте всі переваги платформи лише за {fullaccess} грн/місяць.",
            "buyOrSub": "Відчуйте всі переваги платформи лише від {readonly} грн/міс. або придбайте курс нажавжди, щоб завжди мати до нього доступ.",
            "curated": "Після заповнення заявки на участь ми зв’яжемося з вами впродовж двох днів"
        },

        "defaultTitle": {
            "enroll": "Реєструйтесь на курс",
            "enrollEvent": "Реєструйтесь на подію",
            "isBought": "Курс придбано",
            "isBoughtEvent": "Подію придбано",
            "buyForever": "Придбати курс назавжди",
            "buyForeverEvent": "Придбати подію назавжди",
            "buyCourse": "Придбати курс",
            "buyCourseEvent": "Придбати подію",
            "hasAccess": "Ви маєте доступ до курсу",
            "hasAccessEvent": "Ви маєте доступ до події",
            "subIncludes": "Курс входить в передплату",
            "subIncludesEvent": "Подія входить в передплату",
            "customPricePreface": "Курс створено на підтримку фонду «Повернись живим»",
            "customPrice": "Придбайте курс —  підтримайте «Повернись&nbsp;живим»!",
            "trial": "Спробуйте можливості передплати безкоштовно",
            "subOnly": "Навчайтесь за передплатою",
            "subAccess": "Доступ за передплатою",
            "bundleAccess": "Придбати пакунок курсів",
            "buyOrSub": "Купуйте курс назавжди або навчайтесь за передплатою",
            "buyOrSubEvent": "Купуйте подію назавжди або навчайтесь за передплатою",
            "preRegistration": "Попередня реєстрація"
        },

        "defaultOpts": {
            "fullAccess": "Повний доступ до цього курсу",
            "fullAccessForever": "Повний доступ до цього курсу назавжди",
            "bundleTitle": "Пакунок «{name}»",
            "bundleContent": "Повний доступ до",
            "coursesPlural": "{n} курсів | {n} курсу | {n} курсів | {n} курсів",
            "courses": "курсів пакунку",
            "theoryAccess": "Доступ до теоретичних модулів курсу",
            "subAccess": "Доступ до курсу в період дії передплати",
            "library": "Доступ до інших курсів в бібліотеці",
            "tests": "Можливість складати тести",
            "noHomework": "Можливість здавати домашні роботи",
            "homework": "Рецензії домашніх робіт",
            "updates": "Доступ до всіх оновлень цього курсу",
            "certificate": "Сертифікат про проходження курсу українською та англійською",
            "noCertificate": "Сертифікат про проходження курсу",
            "support": "Служба підтримки"
        },

        "bundlePanel": {
            "accessToCoursesLong": "Купуючи цей пакунок, ви отримаєте довічний доступ до {courses}:"
        },

        "type": {
            "webinar": "Вебінар",
            "workshop": "Онлайн-воркшоп"
        }
    },
    "en": {
        "buyCourse": "Purchase course",
        "register": "Register for the course",
        "buyForever": "Buy lifetime access",

        "buyCourse": "Purchase event",
        "register": "Register for the event",
        "buyForever": "Buy lifetime event",

        "buyBundle": "Buy bundle",
        "toCourse": "To course",
        "toEvent": "To event",
        "startLearning": "Start learning",
        "startFree": "Start free",
        "changePlan": "Change plan",
        "learnMore": "Learn more",
        "fillApplication": "Fill out an application",

        "teamAccess": {
            "textBefore": "We also have plans ",
            "link": "for teams",
            "textAfter": " "
        },

        "pricing": {
            "fullPrice": "Full course price",
            "fromValue": "from {value}",
            "free": "Free",
            "uahMon": "UAH/mon",
            "uah": "UAH",
            "oneTimePayment": "One-time payment",
            "monthlyPaynent": "Monthly payment",
            "priceChangeTimer": "Left until price increase:"
        },

        "plans": {
            "title": "Choose a comfortable plan",
            "description": "Try from the plan for UAH {readonly}/month or experience all the advantages of the platform for only UAH {fullaccess}/month."
        },

        "defaultDesc": {
            "buyForever": "Thus, you’ll still have access to the course and all its learning features (homework checks, certificates, and the ability to view all course materials) even after your subscription expires.",
            "subIncludes": "You can begin your learning journey on this course right away! Your subscription enables you to access all the lessons, engage in practical sessions, receive feedback, and, upon course completion, earn a certificate.",
            "customPricePreface": "<a target=\"_blank\" href=\"https://savelife.in.ua/\" class=\"b-link\">“Come Back Alive”</a> is the first charitable organization in Ukraine to have received a license for procuring and importing military and dual-use goods.",
            "customPricePrefacePoints": {
                "accounting": "Transparent financial reporting",
                "donated": "Raised over 6.6 billion hryvnias",
                "saveLife": "The purchased equipment is saving the lives of our soldiers"
            },
            "customPrice": "You can determine the <strong>course price</strong> yourself, but it cannot be less than {minPrice} UAH.",
            "subOnly": "Try our {readonly} UAH per month plan or enjoy all the platform’s advantages for just {fullaccess} UAH per month.",
            "buyOrSub": "Experience all the platform’s benefits for as little as {readonly} UAH per month, or buy the course for lifetime access.",
            "curated": "After submitting the application for participation, we will contact you within two days"
        },

        "defaultTitle": {
            "enroll": "Enroll",
            "enrollEvent": "Enroll",
            "isBought": "Course is bought",
            "isBoughtEvent": "Event is bought",
            "buyForever": "Buy the course forever",
            "buyForeverEvent": "Buy the event forever",
            "buyCourse": "Buy the course",
            "buyCourseEvent": "Buy the event",
            "hasAccess": "You have access to the course",
            "hasAccessEvent": "You have access to the event",
            "subIncludes": "The course is included in the subscription",
            "subIncludesEvent": "The course is included in the event",
            "customPricePreface": "The course was created in support of the “Come Back Alive” Foundation",
            "customPrice": "Buy the course —  support «Come&nbsp;Back&nbsp;Alive»!",
            "trial": "Try the subscription options for free",
            "subOnly": "Learn by subscription",
            "subAccess": "Access by subscription",
            "bundleAccess": "Buy courses bundle",
            "buyOrSub": "Buy lifetime access to the course or learn by subscription",
            "buyOrSubEvent": "Buy lifetime access to the event or learn by subscription",
            "preRegistration": "Pre-registration"
        },

        "defaultOpts": {
            "fullAccess": "Full access to this course",
            "fullAccessForever": "Full access to this course forever",
            "bundleTitle": "Bundle «{name}»",
            "bundleContent": "Full access to",
            "coursesPlural": "{n} courses | {n} course | {n} courses",
            "courses": "bundle courses",
            "theoryAccess": "Access to theoretical modules of the course",
            "subAccess": "Access to the course during the subscription period",
            "library": "Access to other courses in the library",
            "tests": "Ability to take tests",
            "noHomework": "Ability to hand in homework",
            "homework": "Homework reviews",
            "updates": "Access to all updates of this course",
            "certificate": "Certificate of completion of the course in Ukrainian and English",
            "noCertificate": "Course completion certificate",
            "support": "Support service"
        },

        "bundlePanel": {
            "accessToCoursesLong": "By purchasing this bundle you gain full access to {courses}:"
        },

        "type": {
            "webinar": "Webinar",
            "workshop": "Online Workshop"
        }
    }
}
</i18n>


<template>
    <div
        :id="block.id || `${block.type}-${uid}`"
        class="mt-6 mt-md-8 mt-lg-10"
    >
        <div
            v-if="edit"
            class="page-container"
        >
            <div class="edit">
                <button
                    class="btn-bg btn-lg rounded icon-ic-pencil-outline elevate edit-btn"
                    @click="$emit('openSubscribeEditor')"
                />
            </div>
        </div>

        <!-- Curated course -->
        <template v-if="(!hasAccess || isFree) && block.registerLink && !isEnrollClosed">
            <div class="page-container">

                <Well>
                    <WellCard>
                        <h2 class="wc-title h3 fw-700 my-0">
                            <span v-html="accessContent.title || $t(getI18nTypeKey('defaultTitle.enroll'), locale)" />
                            <div>«{{ course.name }}»</div>
                        </h2>

                        <div class="wc-pricing mt-1 mt-sm-2">
                            <div class="wc-price lg">
                                <span
                                    v-if="heroPricing.label"
                                    class="wc-price-label"
                                >{{ heroPricing.label }}</span>

                                <strike
                                    v-if="heroPricing.discount"
                                    class="wc-price-original"
                                >{{ heroPricing.price }}</strike>

                                <span
                                    v-if="heroPricing.price"
                                    class="wc-price-current"
                                >{{ heroPricing.discount || heroPricing.price }}</span>
                                <span
                                    v-else-if="isFree"
                                    class="wc-price-current"
                                >{{ $t('pricing.free', locale) }}</span>

                                <span
                                    v-if="heroPricing.price || !isFree"
                                    class="wc-price-currency"
                                >{{ heroPricing.suffix || $t(`pricing.${heroPricing.full ? 'uahMon' : 'uah'}`, locale) }}</span>

                                <sup
                                    v-if="heroPricing.discountBadge"
                                    class="wc-price-discount"
                                >{{ heroPricing.discountBadge }}</sup>
                            </div>
                            <div
                                v-if="heroPricing.full"
                                class="wc-price mt-1"
                            >
                                <span
                                    class="wc-price-label"
                                    v-html="`${$t('pricing.fullPrice', locale)}:`"
                                />

                                <strike
                                    v-if="heroPricing.fullDiscount"
                                    class="wc-price-original"
                                >{{ heroPricing.full }}</strike>

                                <span
                                    class="wc-price-current"
                                >{{ heroPricing.fullDiscount || heroPricing.full }}</span>

                                <span
                                    class="wc-price-currency"
                                >{{ heroPricing.fullSuffix || $t('pricing.uah', locale) }}</span>
                            </div>
                            <div
                                v-else-if="heroPricing.byline"
                                class="wc-price mt-1"
                            >
                                <span
                                    v-if="heroPricing.byline.label"
                                    class="wc-price-label"
                                >{{ heroPricing.byline.label }}</span>

                                <strike
                                    v-if="heroPricing.byline.discount && heroPricing.byline.price"
                                    class="wc-price-original"
                                >{{ heroPricing.byline.price }}</strike>

                                <span
                                    v-if="heroPricing.byline.price"
                                    class="wc-price-current"
                                >{{ heroPricing.byline.discount || heroPricing.byline.price }}</span>

                                <span
                                    v-if="heroPricing.byline.suffix"
                                    class="wc-price-currency"
                                >{{ heroPricing.byline.suffix }}</span>
                            </div>
                        </div>

                        <ul v-if="accessContent.options" class="wc-options mt-1 mt-sm-2 mb-0">
                            <li
                                class="wc-option"
                                v-for="(option, i) in accessContent.options"
                                :key="`curated-option-${i}`"
                            >
                                <div :class="option.icon" class="icon mr-1" />
                                {{ option.text }}
                            </li>
                        </ul>

                        <div class="mt-2 mt-sm-3">
                            <a
                                target="_blank"
                                :href="block.registerLink"
                                class="btn btn-rainbow"
                            >
                                <span>{{ $t('fillApplication', locale) }}</span>
                            </a>
                        </div>

                        <div class="wc-muted color-gray-0 mt-2 mt-sm-3">{{ block.helperText || $t('defaultDesc.curated', locale) }}</div>
                    </WellCard>
                </Well>

            </div>
        </template>




        <!-- Course not launched yet -->
        <template v-else-if="!isLaunched">
            <div class="page-container">

                <Well>
                    <WellCard>
                        <h2 class="wc-title h3 fw-700 my-0">{{ $t('defaultTitle.preRegistration', locale) }}</h2>

                        <ul v-if="accessContent.options" class="wc-options mt-1 mt-sm-2 mb-0">
                            <li
                                class="wc-option"
                                v-for="(option, i) in accessContent.options"
                                :key="`curated-option-${i}`"
                            >
                                <div :class="option.icon" class="icon mr-1" />
                                {{ option.text }}
                            </li>
                        </ul>

                        <div class="mt-2 mt-sm-3">
                            <button
                                class="btn btn-rainbow"
                                v-hint="{hint: 'CourseRelease', placement: 'right'}"
                                @click="showNotifyDialog()"
                            >
                                {{ $t('register', locale) }}
                            </button>
                        </div>
                    </WellCard>
                </Well>

            </div>

            <NotifyPanel
                v-if="$auth.loggedIn && $auth.user"
                message="course_release"
            />

        </template>




        <!-- Course is free -->
        <template v-else-if="isFree && (isJoined || !isEnrollClosed)">
            <div class="page-container">

                <Well>
                    <WellCard
                        :checkmark="true"
                    >
                        <h2 class="wc-title h3 fw-700 my-0">{{ $t(getI18nTypeKey('defaultTitle.hasAccess'), locale) }}</h2>

                        <ul v-if="accessContent.options" class="wc-options mt-1 mt-sm-2 mb-0">
                            <li
                                class="wc-option"
                                v-for="(option, i) in accessContent.options"
                                :key="`curated-option-${i}`"
                            >
                                <div :class="option.icon" class="icon mr-1" />
                                {{ option.text }}
                            </li>
                        </ul>

                        <div class="mt-2 mt-sm-3">
                            <nuxt-link
                                v-if="isJoined"
                                :to="localePath(`/learning/course/${course.slug}`)"
                                class="btn btn-rainbow"
                            >
                                {{ $t(course.type == 'event' ? 'toEvent' : 'toCourse', locale) }}
                            </nuxt-link>

                            <JoinCourse
                                v-else-if="!isEnrollClosed"
                                class="btn btn-rainbow"
                                :courseName="course.name"
                                :courseId="course.id"
                                :courseLocale="locale"
                                :courseSlug="course.slug"
                            >
                                {{ $t('startLearning', locale) }}
                            </JoinCourse>
                        </div>
                    </WellCard>
                </Well>

            </div>
        </template>





        <!-- Custom price course -->
        <template v-else-if="canBuyAccess && isCustomPrice && (isJoined || !isEnrollClosed)">

            <!-- Course bought -->
            <template v-if="hasAccess">
                <Well>
                    <WellCard
                        :checkmark="true"
                    >
                        <h2 class="wc-title h3 fw-700 my-0">{{
                            accessContent.boughtTitle ?
                            accessContent.boughtTitle :
                            $t(getI18nTypeKey('defaultTitle.isBought'), locale)
                        }}</h2>

                        <ul v-if="accessContent.options" class="wc-options mt-1 mt-sm-2 mb-0">
                            <li
                                class="wc-option"
                                v-for="(option, i) in accessContent.options"
                                :key="`curated-option-${i}`"
                            >
                                <div :class="option.icon" class="icon mr-1" />
                                {{ option.text }}
                            </li>
                        </ul>

                        <div class="mt-2 mt-sm-3">
                            <nuxt-link
                                v-if="isJoined"
                                :to="localePath(`/learning/course/${course.slug}`)"
                                class="btn btn-rainbow"
                            >
                                {{ $t(course.type == 'event' ? 'toEvent' : 'toCourse', locale) }}
                            </nuxt-link>

                            <JoinCourse
                                v-else-if="!isEnrollClosed"
                                class="btn btn-rainbow"
                                :courseName="course.name"
                                :courseId="course.id"
                                :courseLocale="locale"
                                :courseSlug="course.slug"
                            >
                                {{ $t('startLearning', locale) }}
                            </JoinCourse>
                        </div>
                    </WellCard>
                </Well>
            </template>

            <!-- Custom price buy -->
            <template v-else-if="!isEnrollClosed">
                <div class="page-container">

                    <Card
                        class="card-blurry p-4 mb-3 mb-lg-n4 pb-lg-8 p-xl-8"
                    >
                        <div class="row">

                            <div class="col-12 col-md-10 offset-md-1 col-lg-7 offset-lg-0">
                                <h2 class="h3 fw-800 mt-0 mb-2 ta-md-center ta-lg-left" v-html="customPricePreface.title || $t('defaultTitle.customPricePreface', locale)"></h2>

                                <div class="mb-3" v-html="customPricePreface.text || $t('defaultDesc.customPricePreface', locale)" />

                                <div
                                    v-if="customPricePreface.points"
                                    class="preface-points"
                                >
                                    <div
                                        v-for="(point, i) in customPricePreface.points"
                                        :key="`preface-point-${i}`"
                                        class="preface-point"
                                    >
                                        <span class="icon icon-ic-tick" />

                                        <div class="text" v-html="point" />
                                    </div>
                                </div>
                            </div>

                            <div class="d-none d-lg-block col-lg-5 order-lg-first">
                                <div class="preface-image-wrapper pr-1">
                                    <div class="preface-cba-logo f-shadow">
                                        <img
                                            class="d-block"
                                            :src="customPricePreface.logo || '/images/creative-practice/cases-creation/come-back-alive.svg'"
                                            alt=""
                                            :width="customPricePreface.logoWidth || 97"
                                            :height="customPricePreface.logoHeight || 35"
                                            loading="lazy"
                                        >
                                    </div>

                                    <WebpPicture
                                        class="preface-image"
                                        imgClass="block-image"
                                        src="/images/creative-practice/cases-creation/donate-preface.png"
                                        alt=""
                                        width="352"
                                        height="296"
                                    />
                                </div>
                            </div>

                        </div>
                    </Card>

                    <RainbowCard class="card-donate mx-auto">
                        <div class="row py-4 ta-center">

                            <div class="col-12">
                                <div class="px-2">
                                    <h3 class="h4 h3-md m-0 fw-800" v-html="customPriceContent.title || $t('defaultTitle.customPrice', locale)"></h3>

                                    <div class="mt-1 f-small f-md-normal" v-html="customPriceContent.text || $t('defaultDesc.customPrice', locale, {
                                        minPrice: this.course.minPrice || 0,
                                    })"></div>

                                    <div class="text-wrapper">
                                        <label :for="`come-back-alive-${uid}-field`" class="input-wrapper mt-3">
                                            <input
                                                :id="`come-back-alive-${uid}-field`"
                                                class="come-back-alive-field"
                                                type="text"
                                                v-model="customPrice"
                                                ref="priceinput"
                                            >
                                            <div class="come-back-alive-currency">
                                                {{ $t('pricing.uah', locale) }}
                                            </div>
                                        </label>

                                        <div v-if="customPriceContent.options" class="mt-2">
                                            <div class="d-flex flex-nowrap justify-content-center mn-h">
                                                <button
                                                    v-for="option in customPriceContent.options"
                                                    :key="`come-back-alive-${uid}-option-${option}`"
                                                    @click="setCustomPrice(option)"
                                                    class="btn-bg tt-upper fw-700 elevate m-h"
                                                >{{ option }} {{ $t('pricing.uah', locale) }}</button>
                                            </div>
                                        </div>

                                        <div class="mt-3 d-flex">
                                            <AddToCart
                                                :modelId="block.customPrice?.modelId"
                                                modelName="access"
                                                :price="customPrice"
                                                class="btn-rainbow btn-lg"
                                                @click.native="setCustomPrice(customPrice)"
                                            >{{ customPriceContent.label || $t(getI18nTypeKey('buyCourse'), locale) }}</AddToCart>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </RainbowCard>

                </div>
            </template>

        </template>





        <!-- User has access -->
        <template v-else-if="hasAccess">

            <!-- Sub active, but course can be bought -->
            <template v-if="canBuyAccess && canSubAccess && !isBought && !isEnrollClosed">
                <div class="page-container">

                    <Well>

                        <!-- Access Card -->
                        <WellCard
                            :dark="true"
                        >
                            <div
                                v-if="accessContent?.features || course.type == 'event'"
                                class="mb-2 d-flex align-items-center f-semismall fw-700 mt-1h mt-md-2 mt-lg-0 justify-content-center"
                            >

                                <div
                                    v-if="accessContent?.features?.dates || course.startDate"
                                    class="feature tt-upper"
                                >
                                    <WebpPicture
                                        imgClass="block-image mr-1"
                                        src="https://cdn.cases.media/image/original/calendar-icon.png"
                                        alt="calendar"
                                        width="20"
                                        height="20"
                                    />
                                    {{
                                        accessContent?.features?.dates
                                        || `${$timeformat['dd mmmm ????'](course.startDate, locale)}, ${$timeformat['hh:mm'](course.startDate, locale)}`
                                    }}
                                </div>

                                <!-- Module types -->
                                <div
                                    v-if="accessContent?.features?.type || course.type == 'event'"
                                    class="feature type tt-upper"
                                >
                                    {{
                                        accessContent?.features?.type
                                        || course.moduleTypes.includes('practice')
                                        ? $t('type.workshop', locale)
                                        : $t('type.webinar', locale)
                                    }}
                                </div>
                            </div>

                            <h2 class="wc-title h3 fw-700 my-0">{{ $t(getI18nTypeKey('defaultTitle.buyForever'), locale) }}</h2>

                            <div class="wc-pricing mt-1 mt-sm-2">
                                <div class="wc-price lg">
                                    <strike
                                        v-if="heroPricing.discount"
                                        class="wc-price-original"
                                    >{{ heroPricing.price }}</strike>

                                    <span
                                        class="wc-price-current"
                                    >{{ heroPricing.discount || heroPricing.price }}</span>

                                    <span
                                        class="wc-price-currency"
                                    >{{ heroPricing.suffix || $t(`pricing.${heroPricing.full ? 'uahMon' : 'uah'}`, locale) }}</span>

                                    <sup
                                        v-if="heroPricing.discountBadge"
                                        class="wc-price-discount"
                                    >{{ heroPricing.discountBadge }}</sup>
                                </div>
                                <div class="wc-price mt-1">
                                    <span
                                        class="wc-price-label mr-0"
                                        v-html="$t('pricing.oneTimePayment', locale)"
                                    />
                                </div>
                            </div>

                            <ul class="wc-options mt-1 mt-sm-2 mb-0">
                                <li
                                    class="wc-option"
                                    v-for="(option, i) in optionsBuyAccess"
                                    :key="`curated-option-${i}`"
                                >
                                    <div :class="option.icon" class="icon mr-1" />
                                    {{ option.text }}
                                </li>
                            </ul>

                            <div class="mt-2 mt-sm-3">
                                <AddToCart
                                    modelName="access"
                                    :modelId="course.buyAccess"
                                    class="btn btn-outline"
                                >{{ $t(getI18nTypeKey('buyForever'), locale) }}</AddToCart>
                            </div>
                        </WellCard>


                        <!-- Subscription Card -->
                        <WellCard
                            :checkmark="true"
                        >
                            <h2 class="wc-title h3 fw-700 my-0">{{ $t(getI18nTypeKey('defaultTitle.subIncludes'), locale) }}</h2>

                            <ul class="wc-options mt-1 mt-sm-2 mb-0">
                                <li
                                    class="wc-option"
                                    v-for="(option, i) in subscriptionContent.options"
                                    :key="`curated-option-${i}`"
                                >
                                    <div :class="option.icon" class="icon mr-1" />
                                    {{ option.text }}
                                </li>
                            </ul>

                            <div class="mt-2 mt-sm-3">
                                <nuxt-link
                                    v-if="tokenTheoryOnly"
                                    :to="localePath('/learning/subscription#plans')"
                                    class="btn-secondary fw-600 tt-upper"
                                >
                                    <span>{{ $t('changePlan', locale) }}</span>
                                </nuxt-link>

                                <nuxt-link
                                    v-if="isJoined"
                                    :to="localePath(`/learning/course/${course.slug}`)"
                                    class="btn btn-rainbow"
                                >
                                    {{ $t(course.type == 'event' ? 'toEvent' : 'toCourse', locale) }}
                                </nuxt-link>

                                <JoinCourse
                                    v-else-if="!isEnrollClosed"
                                    class="btn btn-rainbow"
                                    :courseName="course.name"
                                    :courseId="course.id"
                                    :courseLocale="locale"
                                    :courseSlug="course.slug"
                                >
                                    {{ $t(getI18nTypeKey('register'), locale) }}
                                </JoinCourse>
                            </div>
                        </WellCard>
                    </Well>

                </div>
            </template>

            <!-- Course bought -->
            <template v-else-if="isBought && (isJoined || !isEnrollClosed)">
                <div class="page-container">

                    <Well>
                        <WellCard
                            :checkmark="true"
                        >
                            <div
                                v-if="accessContent?.features || course.type == 'event'"
                                class="mb-2 d-flex align-items-center f-semismall fw-700 mt-1h mt-md-2 mt-lg-0 justify-content-center"
                            >

                                <div
                                    v-if="accessContent?.features?.dates || course.startDate"
                                    class="feature tt-upper"
                                >
                                    <WebpPicture
                                        imgClass="block-image mr-1"
                                        src="https://cdn.cases.media/image/original/calendar-icon.png"
                                        alt="calendar"
                                        width="20"
                                        height="20"
                                    />
                                    {{
                                        accessContent?.features?.dates
                                        || `${$timeformat['dd mmmm ????'](course.startDate, locale)}, ${$timeformat['hh:mm'](course.startDate, locale)}`
                                    }}
                                </div>

                                <!-- Module types -->
                                <div
                                    v-if="accessContent?.features?.type || course.type == 'event'"
                                    class="feature type tt-upper"
                                >
                                    {{
                                        accessContent?.features?.type
                                        || course.moduleTypes.includes('practice')
                                        ? $t('type.workshop', locale)
                                        : $t('type.webinar', locale)
                                    }}
                                </div>
                            </div>

                            <h2 class="wc-title h3 fw-700 my-0">{{
                                accessContent.boughtTitle ?
                                accessContent.boughtTitle :
                                $t(getI18nTypeKey('defaultTitle.isBought'), locale)
                            }}</h2>

                            <ul class="wc-options mt-1 mt-sm-2 mb-0">
                                <li
                                    class="wc-option"
                                    v-for="(option, i) in optionsBuyAccess"
                                    :key="`curated-option-${i}`"
                                >
                                    <div :class="option.icon" class="icon mr-1" />
                                    {{ option.text }}
                                </li>
                            </ul>

                            <div class="mt-2 mt-sm-3">
                                <nuxt-link
                                    v-if="isJoined"
                                    :to="localePath(`/learning/course/${course.slug}`)"
                                    class="btn btn-rainbow"
                                >{{
                                    accessContent.boughtEnter ?
                                    accessContent.boughtEnter :
                                    $t(course.type == 'event' ? 'toEvent' : 'toCourse', locale)
                                }}</nuxt-link>

                                <JoinCourse
                                    v-else-if="!isEnrollClosed"
                                    class="btn btn-rainbow"
                                    :courseName="course.name"
                                    :courseId="course.id"
                                    :courseLocale="locale"
                                    :courseSlug="course.slug"
                                >{{
                                    accessContent.boughtEnroll ?
                                    accessContent.boughtEnroll :
                                    $t('startLearning', locale)
                                }}</JoinCourse>
                            </div>
                        </WellCard>
                    </Well>

                </div>
            </template>

            <!-- Course included in sub -->
            <template v-else-if="canSubAccess && (isJoined || !isEnrollClosed)">
                <div class="page-container">

                    <Well>
                        <WellCard
                            :checkmark="true"
                        >
                            <h2 class="wc-title h3 fw-700 my-0">{{ $t(getI18nTypeKey('defaultTitle.subIncludes'), locale) }}</h2>

                            <ul class="wc-options mt-1 mt-sm-2 mb-0">
                                <li
                                    class="wc-option"
                                    v-for="(option, i) in subscriptionContent.options"
                                    :key="`curated-option-${i}`"
                                >
                                    <div :class="option.icon" class="icon mr-1" />
                                    {{ option.text }}
                                </li>
                            </ul>

                            <div class="mt-2 mt-sm-3">
                                <nuxt-link
                                    v-if="tokenTheoryOnly"
                                    :to="localePath('/learning/subscription#plans')"
                                    class="btn-secondary fw-600 tt-upper"
                                >
                                    <span>{{ $t('changePlan', locale) }}</span>
                                </nuxt-link>

                                <nuxt-link
                                    v-if="isJoined"
                                    :to="localePath(`/learning/course/${course.slug}`)"
                                    class="btn btn-rainbow"
                                >
                                    {{ $t(course.type == 'event' ? 'toEvent' : 'toCourse', locale) }}
                                </nuxt-link>

                                <JoinCourse
                                    v-else-if="!isEnrollClosed"
                                    class="btn btn-rainbow"
                                    :courseName="course.name"
                                    :courseId="course.id"
                                    :courseLocale="locale"
                                    :courseSlug="course.slug"
                                >
                                    {{ $t('register', locale) }}
                                </JoinCourse>
                            </div>
                        </WellCard>
                    </Well>

                </div>
            </template>

        </template>





        <!-- User does not have access -->
        <template v-else-if="!isEnrollClosed">

            <!-- Trial block -->
            <template v-if="canTrialAccess && hasTrial">
                <div class="page-container">

                    <div class="mb-3 mb-sm-4 mb-md-5">
                        <h2 class="h4 h3-sm h2-md mt-0 mb-2 mb-sm-3 mb-md-4 ta-center" v-html="$t('defaultTitle.trial', locale)" />
                        <TrialCard :localeToUse="locale" />
                    </div>

                </div>
            </template>

            <!-- Course available to buy (and optionally by sub) -->
            <template v-if="canBuyAccess">
                <div class="page-container">

                    <Well>

                        <!-- Subscription card -->
                        <WellCard
                            v-if="canSubAccess"
                            :dark="true"
                            :timer="subscriptionContent.timerEnd"
                            :timerText="
                                subscriptionContent.timerTitle ?
                                subscriptionContent.timerTitle :
                                $t('pricing.priceChangeTimer', locale)
                            "
                        >
                            <h2 class="wc-title h3 fw-700 my-0"> {{
                                subscriptionContent.title ?
                                subscriptionContent.title :
                                $t('defaultTitle.subAccess', locale)
                            }} </h2>

                            <div class="wc-pricing mt-1 mt-sm-2">
                                <div class="wc-price lg">
                                    <span
                                        class="wc-price-current"
                                    >{{ $t('pricing.fromValue', locale, {
                                        value:  platformPricing.subscriptionReadOnly || 250,
                                    }) }}</span>

                                    <span
                                        class="wc-price-currency"
                                    >{{ heroPricing.suffix || $t('pricing.uahMon', locale) }}</span>
                                </div>
                                <div class="wc-price mt-1">
                                    <span
                                        class="wc-price-label mr-0"
                                        v-html="$t('pricing.monthlyPaynent', locale)"
                                    />
                                </div>
                            </div>

                            <ul class="wc-options mt-1 mt-sm-2 mb-0">
                                <li
                                    class="wc-option"
                                    v-for="(option, i) in subscriptionContent.options"
                                    :key="`curated-option-${i}`"
                                >
                                    <div :class="option.icon" class="icon mr-1" />
                                    {{ option.text }}
                                </li>
                            </ul>

                            <div class="mt-2 mt-sm-3">
                                <nuxt-link
                                    :to="localePath('/learning/subscription#plans')"
                                    class="btn btn-outline"
                                >{{ $t('learnMore', locale) }}</nuxt-link>
                            </div>
                        </WellCard>

                        <!-- Purchase bundle card -->
                        <WellCard
                            v-if="!canSubAccess && canBundleAccess"
                            :dark="true"
                            :timer="timerEnd"
                            :timerText="$t('pricing.priceChangeTimer', locale)"
                        >
                            <h2 class="wc-title h3 fw-700 my-0">{{ $t('defaultTitle.bundleAccess', locale) }}</h2>

                            <div class="wc-pricing mt-1 mt-sm-2">
                                <div class="wc-price lg">
                                    <strike
                                        v-if="featuredBundle.discountedPrice"
                                        class="wc-price-original"
                                    >{{ featuredBundle.fullPrice }}</strike>

                                    <span
                                        class="wc-price-current"
                                    >{{ featuredBundle.discountedPrice || featuredBundle.fullPrice }}</span>

                                    <span
                                        class="wc-price-currency"
                                    >{{ $t('pricing.uah', locale) }}</span>

                                    <sup
                                        v-if="featuredBundle.discountBadge"
                                        class="wc-price-discount"
                                    >{{ featuredBundle.discountBadge }}</sup>
                                </div>
                                <div class="wc-price mt-1">
                                    <span
                                        class="wc-price-label mr-0"
                                        v-html="$t('pricing.oneTimePayment', locale)"
                                    />
                                </div>
                            </div>

                            <ul class="wc-options mt-1 mt-sm-2 mb-0">
                                <li
                                    class="wc-option"
                                    v-for="(option, i) in optionsBundleAccess"
                                    :key="`curated-option-${i}`"
                                >
                                    <div :class="option.icon" class="icon mr-1" />
                                    <template v-if="option.text == 'bundleContent'">
                                        {{ $t(`defaultOpts.${option.text}`, locale) }}&nbsp;
                                        <PanelButton
                                            v-if="featuredBundle?.courses?.length"
                                            name="bundle-panel"
                                            class="b-link fw-700"
                                        >{{ $tc('defaultOpts.coursesPlural', featuredBundle.courses.length, { locale }) }}</PanelButton>
                                        <span v-else>{{ $t('defaultOpts.courses', locale) }}</span>
                                    </template>
                                    <template v-else>{{ option.text }}</template>
                                </li>
                            </ul>

                            <div class="mt-2 mt-sm-3">
                                <AddToCart
                                    modelName="access"
                                    :modelId="featuredBundle.access"
                                    class="btn btn-outline"
                                >{{ $t('buyBundle', locale) }}</AddToCart>
                            </div>
                        </WellCard>


                        <!-- Purchase access card -->
                        <WellCard
                            :timer="timerEnd"
                            :timerText="
                                accessContent.timerTitle ?
                                accessContent.timerTitle :
                                $t('pricing.priceChangeTimer', locale)
                            "
                        >
                            <div
                                v-if="accessContent?.features || course.type == 'event'"
                                class="mb-2 d-flex align-items-center f-semismall fw-700 mt-1h mt-md-2 mt-lg-0 justify-content-center"
                            >

                                <div
                                    v-if="accessContent?.features?.dates || course.startDate"
                                    class="feature tt-upper"
                                >
                                    <WebpPicture
                                        imgClass="block-image mr-1"
                                        src="https://cdn.cases.media/image/original/calendar-icon.png"
                                        alt="calendar"
                                        width="20"
                                        height="20"
                                    />
                                    {{
                                        accessContent?.features?.dates
                                        || `${$timeformat['dd mmmm ????'](course.startDate, locale)}, ${$timeformat['hh:mm'](course.startDate, locale)}`
                                    }}
                                </div>

                                <!-- Module types -->
                                <div
                                    v-if="accessContent?.features?.type || course.type == 'event'"
                                    class="feature type tt-upper"
                                >
                                    {{
                                        accessContent?.features?.type
                                        || course.moduleTypes.includes('practice')
                                        ? $t('type.workshop', locale)
                                        : $t('type.webinar', locale)
                                    }}
                                </div>
                            </div>

                            <h2 class="wc-title h3 fw-700 my-0">
                                {{
                                    accessContent.title ?
                                    accessContent.title :
                                    $t(getI18nTypeKey(`defaultTitle.${!canSubAccess && canBundleAccess ? 'buyCourse' : 'buyForever'}`), locale)
                                }}
                            </h2>

                            <div class="wc-pricing mt-1 mt-sm-2">
                                <div class="wc-price lg">
                                    <strike
                                        v-if="heroPricing.discount"
                                        class="wc-price-original"
                                    >{{ heroPricing.price }}</strike>

                                    <span
                                        class="wc-price-current"
                                    >{{ heroPricing.discount || heroPricing.price }}</span>

                                    <span
                                        class="wc-price-currency"
                                    >{{ heroPricing.suffix || $t(`pricing.${heroPricing.full ? 'uahMon' : 'uah'}`, locale) }}</span>

                                    <sup
                                        v-if="heroPricing.discountBadge"
                                        class="wc-price-discount"
                                    >{{ heroPricing.discountBadge }}</sup>
                                </div>
                                <div class="wc-price mt-1">
                                    <span
                                        class="wc-price-label mr-0"
                                        v-html="$t('pricing.oneTimePayment', locale)"
                                    />
                                </div>
                            </div>

                            <ul class="wc-options mt-1 mt-sm-2 mb-0">
                                <li
                                    class="wc-option"
                                    v-for="(option, i) in optionsBuyAccess"
                                    :key="`curated-option-${i}`"
                                >
                                    <div :class="option.icon" class="icon mr-1" />
                                    {{ option.text }}
                                </li>
                            </ul>

                            <div class="mt-2 mt-sm-3">
                                <AddToCart
                                    modelName="access"
                                    :modelId="course.buyAccess"
                                    class="btn btn-rainbow"
                                >{{ $t(getI18nTypeKey(!canSubAccess && canBundleAccess ? 'buyCourse' : 'buyForever'), locale) }}</AddToCart>
                            </div>
                        </WellCard>

                    </Well>

                </div>

                <!-- Bundle info panel -->
                <Panel
                    v-if="canBundleAccess"
                    modal-name="bundle-panel"
                    side="right"
                    :noTitle="true"
                    :classes="['bundle-panel', 'h-100']"
                >
                    <div class="bundle-panel-wrapper d-flex flex-column h-100">

                        <div class="bundle-panel-content p-2 pb-1">
                            <h3 class="mt-0 mb-1 fw-800 pr-4" v-html="featuredBundle?.name"></h3>

                            <div
                                v-if="featuredBundle?.fullPrice"
                                class="bundle-price mb-1"
                            >
                                <del
                                    v-if="featuredBundle?.discountedPrice"
                                    class="original-value"
                                    v-html="featuredBundle?.fullPrice"
                                />

                                <span class="value">
                                    <span class="fw-700" v-html="featuredBundle?.discountedPrice || featuredBundle?.fullPrice" />
                                    <span class="currency">{{ $t('pricing.uah', locale) }}</span>
                                </span>

                                <span
                                    v-if="featuredBundle?.discountBadge"
                                    class="discount-value"
                                >{{ featuredBundle.discountBadge }}</span>
                            </div>

                            <div class="mb-1">{{ $t('bundlePanel.accessToCoursesLong', {
                                courses: $tc('defaultOpts.coursesPlural', featuredBundle?.courses?.length, {
                                    locale,
                                }),
                                locale,
                            }) }}</div>

                            <div class="bundle-panel-courses">
                                <LinkCard
                                    v-for="(course, i) in featuredBundle?.courses"
                                    :key="`bundle-course-${i}`"
                                    :to="localePath(`/learning/course/${course.slug}/about`)"
                                    class="bundle-course p-1 mt-1"
                                    target="_blank"
                                >
                                    <WebpPicture
                                        class="icon"
                                        :src="course.icon"
                                        width="48"
                                        height="48"
                                        loading="lazy"
                                    />

                                    <div class="name">
                                        {{ course.name }}
                                    </div>
                                </LinkCard>
                            </div>
                        </div>
                        <div class="bundle-panel-footer p-2">
                            <AddToCart
                                modelName="access"
                                :modelId="featuredBundle?.access"
                                class="btn-primary fw-700"
                            >
                                {{ $t('buyBundle', locale) }}
                            </AddToCart>
                        </div>

                    </div>
                </Panel>
            </template>

            <!-- Course only available by sub -->
            <template v-else-if="canSubAccess">

                <Plans
                    id="plans"
                    :locale="locale"
                    :title="$t('plans.title', locale)"
                    :description="$t('plans.description', locale, {
                        readonly: platformPricing.subscriptionReadOnly || 250,
                        fullaccess: platformPricing.subscriptionFullAccess || 550,
                    })"
                    :plans="plans"
                    :courses="planCourses"
                    class="mt-8 mt-md-10 mt-lg-12 transition-up-8"
                />

            </template>

        </template>

    </div>
</template>


<script>
    import { useCourseLandingStore } from '~/stores/courseLanding';

    let uid = 0;

    import blockPropertyObject from '~/mixins/course-landing/blockPropertyObject.js';
    import courseStates        from '~/mixins/course-landing/courseStates.js';
    import accessPlans         from '~/mixins/course-landing/accessPlans.js';
    import { platformPricing } from '~/utilities/pricing';

    export default {
        props: {
            block: Object,
            edit:  Boolean,
        },

        components: {
            AddToCart:          () => import('~/components/cart/AddToCart.vue'),
            Card:               () => import('~/components/cards/Card.vue'),
            JoinCourse:         () => import('~/components/creative-practice/JoinCourseButton.vue'),
            LinkCard:           () => import('~/components/cards/LinkCard.vue'),
            NotifyPanel:        () => import('~/components/panels/NotifyPanel.vue'),
            Panel:              () => import('~/components/panels/CasesPanel.vue'),
            PanelButton:        () => import('~/components/panels/PanelButton.vue'),
            Plans:              () => import('~/components/creative-practice/pr-landings/Plans.vue'),
            RainbowCard:        () => import('~/components/cards/RainbowCard.vue'),
            TrialCard:          () => import('~/components/subscription/TrialSection.vue'),
            WebpPicture:        () => import('~/components/WebpPicture.vue'),
            Well:               () => import('~/components/creative-practice/course-landing/Subscribe/Well.vue'),
            WellCard:           () => import('~/components/creative-practice/course-landing/Subscribe/Card.vue'),
        },

        mixins: [
            blockPropertyObject,
            courseStates,
            accessPlans,
        ],

        data () {
            uid++;

            return {
                customPrice: 0,

                platformPricing,

                uid,
            };
        },

        computed: {
            locale () {
                return this.courseLandingStore.locale;
            },

            course () {
                return this.courseLandingStore.course;
            },

            plans () {
                return this.courseLandingStore.plans;
            },

            planCourses () {
                return this.courseLandingStore.planCourses;
            },

            courseLandingStore () {
                return useCourseLandingStore();
            },


            customPricePreface () {
                if (!this.isCustomPrice) return {};

                let obj = this.block.customPrice && this.block.customPrice.preface || {};

                if (!obj.points) obj.points = [
                    this.$t('defaultDesc.customPricePrefacePoints.accounting', this.locale),
                    this.$t('defaultDesc.customPricePrefacePoints.donated', this.locale),
                    this.$t('defaultDesc.customPricePrefacePoints.saveLife', this.locale),
                ];

                return obj;
            },

            customPriceContent () {
                if (!this.isCustomPrice) return {};

                return this.block.customPrice && this.block.customPrice.content || {};
            },

            defaultOptionsFree () {
                return [
                    this.$t('defaultOpts.fullAccess', this.locale),
                    this.$t('defaultOpts.updates', this.locale),
                    this.$t('defaultOpts.certificate', this.locale),
                    {
                        icon: 'icon-ic-favourite-outline color-green',
                        text: this.$t('defaultOpts.support', this.locale),
                    },
                ];
            },

            defaultOptionsCustomPrice () {
                return [
                    this.$t('defaultOpts.fullAccess', this.locale),
                    this.$t('defaultOpts.homework', this.locale),
                    this.$t('defaultOpts.updates', this.locale),
                    this.$t('defaultOpts.certificate', this.locale),
                    {
                        icon: 'icon-ic-favourite-outline color-green',
                        text: this.$t('defaultOpts.support', this.locale),
                    },
                ];
            },

            optionsBuyAccess () {
                if (this.accessContent.options?.length) {
                    return this.accessContent.options;
                }

                if (this.canBundleAccess) {
                    return this.convertOptions([
                        this.$t('defaultOpts.fullAccess', this.locale),
                        this.$t('defaultOpts.homework', this.locale),
                        this.$t('defaultOpts.updates', this.locale),
                        this.$t('defaultOpts.certificate', this.locale),
                        {
                            icon: 'icon-ic-favourite-outline color-green',
                            text: this.$t('defaultOpts.support', this.locale),
                        },
                    ]);
                }

                return this.convertOptions([
                    this.$t('defaultOpts.fullAccessForever', this.locale),
                    this.$t('defaultOpts.homework', this.locale),
                    this.$t('defaultOpts.updates', this.locale),
                    this.$t('defaultOpts.certificate', this.locale),
                    {
                        icon: 'icon-ic-favourite-outline color-green',
                        text: this.$t('defaultOpts.support', this.locale),
                    },
                ]);
            },

            optionsBundleAccess () {
                return this.convertOptions([
                    this.$t('defaultOpts.bundleTitle', this.locale, {
                        name: this.featuredBundle.name,
                    }),
                    'bundleContent',
                    this.$t('defaultOpts.certificate', this.locale),
                    {
                        icon: 'icon-ic-favourite-outline color-green',
                        text: this.$t('defaultOpts.support', this.locale),
                    },
                ]);
            },

            optionsSubAccess () {
                if (this.tokenTheoryOnly) {
                    return this.convertOptions([
                        this.$t('defaultOpts.theoryAccess', this.locale),
                        this.$t('defaultOpts.tests', this.locale),
                        {
                            icon: 'icon-ic-dismiss color-red',
                            text: this.$t('defaultOpts.noHomework', this.locale),
                        },
                        {
                            icon: 'icon-ic-dismiss color-red',
                            text: this.$t('defaultOpts.homework', this.locale),
                        },
                        {
                            icon: 'icon-ic-dismiss color-red',
                            text: this.$t('defaultOpts.noCertificate', this.locale),
                        },
                        {
                            icon: 'icon-ic-favourite-outline color-green',
                            text: this.$t('defaultOpts.support', this.locale),
                        },
                    ]);
                }

                if (this.canBuyAccess && !this.isBought) {
                    return this.convertOptions([
                        this.$t('defaultOpts.subAccess', this.locale),
                        this.$t('defaultOpts.library', this.locale),
                        this.$t('defaultOpts.updates', this.locale),
                        this.$t('defaultOpts.certificate', this.locale),
                        {
                            icon: 'icon-ic-favourite-outline color-green',
                            text: this.$t('defaultOpts.support', this.locale),
                        },
                    ]);
                }

                return this.convertOptions([
                    this.$t('defaultOpts.fullAccess', this.locale),
                    this.$t('defaultOpts.homework', this.locale),
                    this.$t('defaultOpts.updates', this.locale),
                    this.$t('defaultOpts.certificate', this.locale),
                    {
                        icon: 'icon-ic-favourite-outline color-green',
                        text: this.$t('defaultOpts.support', this.locale),
                    },
                ]);
            },

            accessContent () {
                let obj = Object.assign({
                    options: []
                }, this.block.content);

                if (this.isFree && obj.options !== false && !obj.options?.length) {
                    obj.options = this.defaultOptionsFree;
                }

                if (this.canBuyAccess && this.isCustomPrice && obj.options !== false && !obj.options?.length) {
                    obj.options = this.defaultOptionsCustomPrice;
                }

                if (obj.options !== false) {
                    obj.options = this.convertOptions(obj.options);
                }

                return obj;
            },

            subscriptionContent () {
                let obj = Object.assign({
                    options: []
                }, this.block.subscriptionContent);

                if (obj.options.length == 0) {
                    obj.options = this.optionsSubAccess;
                }

                obj.options = this.convertOptions(obj.options);

                return obj;
            },

            heroPricing () {
                const heroBlock = this.course.blocks.find(block => {
                    if (block.disabled) return false;

                    const type = block.type.toLowerCase();

                    return type == 'hero';
                });

                let obj = {
                    price:    false,
                    discount: false,
                    label:    false,
                    suffix:   false,

                    full:         false,
                    fullDiscount: false,
                    fullSuffix:   false,

                    discountBadge: false,
                    minPrice:      false,

                    byline: false,
                };

                if (this.block.pricing) {
                    obj = Object.assign(obj, this.blockPropertyObject(this.block.pricing, 'price'));
                } else if (heroBlock) {
                    obj = Object.assign(obj, this.blockPropertyObject(heroBlock.pricing, 'price'));
                }

                if (!obj.price && this.course.price) obj.price = this.course.price;
                if (!obj.discount && this.course.priceDiscount) obj.discount = this.course.priceDiscount;
                if (obj.price && obj.discount && !obj.discountBadge) {
                    let value = obj.price - obj.discount;
                    obj.discountBadge = `-${Math.floor(value * 100 / obj.price)}%`;
                }

                if (this.isCustomPrice && this.course.minPrice) {
                    obj.minPrice = this.course.minPrice;
                }

                return obj;
            },

            featuredBundle () {
                let obj = this.course.featuredBundle || {};

                if (obj.fullPrice && obj.discountedPrice) {
                    let value = obj.fullPrice - obj.discountedPrice;
                    obj.discountBadge = `-${Math.floor(value * 100 / obj.fullPrice)}%`;
                }

                return obj;
            },


            timerEnd () {
                let time = false; //this.course.type == 'event' ? this.course.startDate : false;
                if (this.accessContent.timerEnd) time = this.accessContent.timerEnd;
                if (!time) return false;
                return new Date(time);
            },

            hasPriceChangeTimer () {
                return this.timerEnd && this.timerEnd > new Date();
            },
        },

        mounted () {
            if (process.browser) {
                this.setCustomPrice(0);
                this.observe();
            }
        },

        methods: {
            getI18nTypeKey (key) {
                return this.course.type == 'event' ? key+'Event' : key;
            },

            showNotifyDialog () {
                if (!this.$auth.loggedIn || !this.$auth.user) return this.showLoginDialog();

                this.$modalityStore.openModal({
                    type: 'drawer',
                    name: 'notify',
                });
            },

            showLoginDialog () {
                this.$modalityStore.openModal({
                    type: 'drawer',
                    name: 'login',
                    message: 'login.401.coursePreRegister'
                })
            },


            setCustomPrice (value) {
                if (value < this.course.minPrice) value = this.course.minPrice;
                this.customPrice = value;
            },


            convertOptions (options) {
                return options.map(option => {
                    return Object.assign({
                        icon: 'icon-ic-tick-thin color-green',
                    }, this.blockPropertyObject(option, 'text'));
                });
            },


            observe () {
                this.observer = new IntersectionObserver((entries) => {
                    const entry = entries.find(e => e.isIntersecting);
                    const visible = entry && entry.intersectionRatio >= 0.25;
                    this.$emit('intersection', {
                        type: 'Subscribe',
                        threshold: 0.25,
                        isVisible: visible
                    });
                }, {
                    rootMargin: '0px',
                    threshold: [0, 0.03, 0.1, 0.25, 0.5, 0.75, 1.0]
                });

                const blockId = this.block.id || `${this.block.type}-${this.uid}`;

                const el = document.querySelector(`#${blockId}`);
                if (el) this.observer.observe(el);
            },

            unobserve: function () {
                if (this.observer) this.observer.disconnect();
            },
        },

        destroyed () {
            this.unobserve();
        },
    }
</script>


<style lang="postcss" scoped>
    .feature {
        display: inline-flex;
        align-items: center;

        & + &::before {
            content:     '';
            display: block;
            background-color: var(--color-cases-gray-2);
            margin: 0 8px;
            width: 4px;
            height: 4px;
            border-radius: 50%;

            @media (prefers-color-scheme: dark) {
                background-color: rgba(255, 255, 255, .5);
            }

            [data-theme='dark'] & {
                background-color: rgba(255, 255, 255, .5);
            }

            [data-theme='light'] & {
                background-color: var(--color-cases-gray-2);
            }

            @media screen and (min-width: 992px) {
                background-color: #878D99;

                .hero-block.dark & {
                    background-color: rgba(255, 255, 255, .5);
                }
            }
        }
    }

    .btn-light {
        color:          #0E1014;
        font-size:      14px;
        font-weight:    700;
        letter-spacing: initial;
        line-height:    16px;
        text-transform: uppercase;

        background: #fff;
        box-shadow: 0 1px 4px 0 rgba(9, 10, 13, 0.12),
                    0 1px 1px 0 rgba(9, 10, 13, 0.08),
                    0 0 0 3px rgba(255, 255, 255, 0.30);
        transition: color .1s ease,
               box-shadow .1s ease;

        border-radius: 9000px;
        padding:       8px 16px;

        display: flex;
        width:   100%;

        @media screen and (min-width: 768px) {
            padding: 16px 24px;

            display: inline-flex;
            width:   auto;
        }

        &:hover {
            color: #595E69;
            box-shadow: 0 0 3px rgba(14, 16, 20, 0.08),
                        0 4px 8px rgba(9, 10, 13, 0.12),
                        0 0 1px rgba(113, 120, 133, 0.24),
                        0 0 0 0 rgba(27, 139, 224, 0.32);
        }

        &:active {
            box-shadow: 0 0 2px rgba(9, 10, 13, 0.24),
                        0 0 0 rgba(9, 10, 13, 0.12),
                        0 0 1px rgba(113, 120, 133, 0.24),
                        0 0 0 0 rgba(27, 139, 224, 0.32);
        }
    }

    .btn-rainbow.btn-lg {
        display: flex;
        width:   100%;

        @media screen and (min-width: 768px) {
            font-size:   21px;
            line-height: 24px;

            padding: 16px 24px;

            display: inline-flex;
            width:   auto;
        }

        .card-donate & {
            flex: 1 0 100%;
        }
    }

    .rainbow-content {
        margin: -4px;
    }

    .h-stretch {
        height: 100%;

        :deep(.gradient-card-body) {
            height: 100%;
        }

        &.rainbow-content {
            height: calc(100% + 8px);
        }
    }

    .h-flex {
        display:     flex;
        flex-flow:   column nowrap;
        align-items: stretch;
        height:      100%;

        .h-flex-grow {
            flex: 1 0 auto;
        }
    }

    .card-blurry {
        background: radial-gradient(33.91% 145.63% at -2.28% -45.62%, #FFF9E0 0%, rgba(255, 235, 237, 0) 100%), linear-gradient(145.58deg, #EBF7FF 20.33%, rgba(235, 241, 255, 0.65) 75.47%), #FFEBED;

        @media (prefers-color-scheme: dark) {
            background: linear-gradient(109.16deg, #2F2A3D 15.16%, #512844 97.11%);
        }

        [data-theme='light'] & {
            background: radial-gradient(33.91% 145.63% at -2.28% -45.62%, #FFF9E0 0%, rgba(255, 235, 237, 0) 100%), linear-gradient(145.58deg, #EBF7FF 20.33%, rgba(235, 241, 255, 0.65) 75.47%), #FFEBED;
        }

        [data-theme='dark'] & {
            background: linear-gradient(109.16deg, #2F2A3D 15.16%, #512844 97.11%);
        }
    }

    .preface-point {
        display:     flex;
        flex-flow:   row nowrap;
        align-items: flex-start;

        .icon {
            font-size: 12px;

            margin: 6px 0;
            margin-right: 16px;

            flex:   0 0 16px;
            height: 12px;
        }

        & + & {
            margin-top: 16px;
        }
    }

    .preface-image-wrapper {
        position: relative;

        max-width: 316px;
    }

    :deep(.preface-image img) {
        border-radius: 8px;
    }

    .preface-cba-logo {
        background: #fff;

        padding:       16px;
        border-radius: 8px;

        position: absolute;
        top:      -16px;
        right:    -8px;

        @media screen and (min-width: 1200px) {
            top:   -32px;
            right: -32px;
        }
    }

    .card-donate {
        max-width: 625px;
    }

    .input-wrapper {
        background: var(--color-cases-gray-5);

        border-radius: 8px;
        padding:       0 70px;

        display: block;

        position: relative;
    }

    .come-back-alive-currency,
    .come-back-alive-field {
        color:       var(--color-cases-text);
        font-size:   24px;
        font-weight: 600;
        line-height: 1.5;
    }

    .come-back-alive-field {
        text-align:  center;

        appearance: none;
        background: transparent;

        outline: 0;
        margin:  0;
        border:  0;
        padding: 6px 12px;

        display: block;
        width:   100%;
    }

    .come-back-alive-currency {
        padding: 6px 12px;

        display: block;

        position: absolute;
        top:      0;
        right:    0;
    }

    .text-wrapper {
        margin: 0 auto;

        max-width: 340px;
    }

    .img-bg {
        background: linear-gradient(129.17deg, rgba(129, 91, 166, 0.15) 16.46%, rgba(235, 73, 132, 0.15) 40.64%, rgba(245, 107, 97, 0.15) 62.87%, rgba(250, 140, 64, 0.15) 82.69%, rgba(253, 197, 11, 0.15) 103.72%);

        margin: -32px 0;

        display:         flex;
        height:          calc(100% + 64px);
        flex-flow:       row nowrap;
        align-items:     center;
        justify-content: center;
    }

    .desc {
        @media screen and (min-width: 576px) {
            font-size:   19px;
            line-height: 1.263158;
        }

        @media screen and (min-width: 992px) {
            font-size:   24px;
            line-height: 1.166667;
        }
    }

    .bundle-panel-wrapper {
        min-height: 100%;
    }

    .bundle-panel-content {
        flex-grow: 1;

        overflow: auto;
    }

    .bundle-panel-footer {
        display:     flex;
        flex-flow:   column nowrap;
        align-items: stretch;

        &.elevate {
            box-shadow: 0 0 3px var(--color-cases-shadow-1),
                        0 16px 32px -4px var(--color-cases-shadow-2),
                        0 0 1px var(--color-cases-shadow-border);
        }
    }

    .bundle-price {
        color:       #ED4A79;
        font-size:   32px;
        line-height: 1;

        display:     flex;
        flex-flow:   row nowrap;
        align-items: baseline;

        &.small {
            font-size: 24px;
        }

        .original-value {
            margin-right: 8px;
        }

        .value {
            line-height: 1.5;

            background: linear-gradient(109deg, #ED4A79 29.16%, #F4912C 87%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;

            margin: -8px 0;

            display:     flex;
            flex-flow:   row nowrap;
            align-items: baseline;
        }

        .discount-value {
            color:       var(--color-cases-black);
            font-size:   12px;
            font-weight: 700;
            line-height: 1.666667;

            background: var(--color-cases-cadmium-yellow);

            margin-left:   8px;
            padding:       0 4px;
            border-radius: 4px;

            align-self: flex-start;
        }
    }

    .bundle-course {
        display:         flex;
        flex-flow:       row nowrap;
        align-items:     center;
        justify-content: flex-start;

        :deep(img) {
            border-radius: 8px;

            display: block;
        }

        .icon {
            margin-right: 8px;

            display:    block;
            align-self: flex-start;
            flex:       0 0 auto;
        }

        .name {
            font-weight: 700;

            flex: 1 1 auto;
        }
    }

    .edit {
        position: relative;
    }

    .edit-btn {
        position: absolute;
        top:      -6px;
        right:    -8px;
        z-index:  10;
    }
</style>
